import { MAIL_TEMPLATE } from './mail-template'

export const CAREER = `{
  id
  name
  title
  status
  archived
  is_available_in_attract
  logo
  photo_url
  language
  category
  partner_id
  authorized_create
  authorized_read
  authorized_update
  authorized_delete
  external_link
  app_settings {
    components
    challenges
    cultural_fit
    application_input_additional_fields
    mail_template ${MAIL_TEMPLATE}
    mail_template_reminder ${MAIL_TEMPLATE}
    mail_template_reject ${MAIL_TEMPLATE}
  }
  challenge_config_id
  career_analyse
  createdAt
  updatedAt
  redirect_url
  copy_from_career_id
  external_custom_id
  diagnostic_version
  customer_dashboard_meta
}`
